import React, { useState, useEffect } from "react";
import StockDataPage from "./pages/StockDataPage";
import LoginPage from "./pages/LoginPage";
import StockDetailsPage from "./pages/StockDetailsPage";
import { ToastContainer, toast } from "react-toastify";
import { auth, firestore } from "./firebase/firebase";
import { doc, getDoc, updateDoc } from "firebase/firestore"; // Firestore functions

import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Function to check if user is logged in Firestore and verify token
  const checkFirestoreLogin = async (firebaseUser) => {
    try {
      const userId = firebaseUser.uid;
      const idToken = await firebaseUser.getIdToken(); // Get current user token

      // Fetch user data from Firestore based on user ID
      const userDocRef = doc(firestore, "users", userId);
      const userDoc = await getDoc(userDocRef);

      if (userDoc.exists()) {
        const userData = userDoc.data();
        console.log("Firestore user data:", userData);

        // Check if the user is logged in and the token matches
        if (userData.isLoggedIn && userData.token === idToken) {
          setUser(firebaseUser);
        } else if (userData.isLoggedIn && userData.token !== idToken) {
          await updateDoc(doc(firestore, "users", userId), {
            token: idToken,
          });
          setUser(firebaseUser);
        } else {

          // If token doesn't match or not logged in, set user to null
          setUser(null);
          console.warn("User is not logged in or token mismatch in Firestore");
        }
      } else {
        console.warn("No such user document in Firestore");
        setUser(null);
      }
    } catch (error) {
      console.error("Error checking user in Firestore:", error);
      setUser(null);
    } finally {
      setLoading(false); // Set loading to false after checking
    }
  };

  // Check if user is already logged in on page load
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((firebaseUser) => {
      if (firebaseUser) {
        // Check login status and token in Firestore
        checkFirestoreLogin(firebaseUser);
      } else {
        setUser(null);
        setLoading(false);
      }
    });

    // Clean up the subscription when the component unmounts
    return () => unsubscribe();
  }, []);

  if (loading) {
    return <div>Loading...</div>; // Show a loading state until Firebase finishes checking
  }

  return (
    <div className="flex items-center justify-center p-0 m-0">
      <Router>
        <Routes>
          <Route
            path="/"
            element={user ? <Navigate to="/stockdata" /> : <LoginPage />}
          />

          <Route
            path="/stockdetailspage/:stockId"
            element={user ? <StockDetailsPage /> : <Navigate to="/" />}
          />

          {/* Default route - login page */}
          <Route path="/" element={<LoginPage />} />

          {/* Stock data page */}
          <Route
            path="/stockdata"
            element={user ? <StockDataPage /> : <Navigate to="/" />}
          />

          {/* Catch-all route for 404 errors */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
      <ToastContainer />
    </div>
  );
}

export default App;
